<template>
  <div style="height: 100%;">
    <slot></slot>
    <div v-show="visible" class="loading">
      <div class="ks-floating-menu loading-dialog">
        <div class="left">
          <k-progress-circular v-show="!error" indeterminate v-bind:size="40"></k-progress-circular>
        </div>

        <div class="content"><slot name="infoContent"></slot></div>

        <div class="right"><slot name="right"></slot></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["visible", "error"]
}
</script>

<style scoped>
.loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--ks-background-color-op60);
  z-index: var(--ks-z-loading, 7);
  overflow-y: auto;
  padding: 24px;
  overflow: hidden;

}
.loading .left {
  display: flex;
  align-items: center;
}
.loading .right {
  display: flex;
  align-items: center;
}

.loading .loading-dialog {
  padding: 20px;
  display: grid;
  grid-gap: 20px;
  grid-template-columns: max-content 300px max-content;
}
.loading .content {
  display: flex;
  align-items: center;
}
</style>
